import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AgentPermissionSummary,
  AgentPermissionUser,
  AssignAgentPermissionRequest,
} from 'app/_models/agent-permission';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AgentPermissionsService {
  private readonly baseUrl = `${environment.accountUrl}/api/v1/agent-permissions`;

  constructor(private http: HttpClient) {}

  public listPermissions(): Observable<AgentPermissionSummary[]> {
    return this.http.get<AgentPermissionSummary[]>(this.baseUrl);
  }

  public listUsersByAgent(agentId: string): Observable<AgentPermissionUser[]> {
    return this.listPermissions().pipe(
      map(permissions => {
        const summary = permissions?.find(
          permission => permission.agentId?.toString() === agentId?.toString()
        );
        return summary?.users ?? [];
      })
    );
  }

  public listAgentsByUser(userId: string): Observable<string[]> {
    return this.http.get<string[]>(`${this.baseUrl}/users/${userId}`);
  }

  public assignToAgent(
    userId: string,
    agentId: string
  ): Observable<AgentPermissionSummary> {
    const payload: AssignAgentPermissionRequest = { agentId };
    return this.http.post<AgentPermissionSummary>(
      `${this.baseUrl}/users/${userId}`,
      payload
    );
  }

  public removeFromAgent(agentId: string, userId: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${agentId}/users/${userId}`);
  }
}

